import * as React from 'react';
import { Box, FormHelperText, makeStyles, createStyles } from '@material-ui/core';
import RenderText from '../../../dictionaries/RenderText';
import { MAX_VALIDATION_ATTEMPTS } from '../validationConfig';
import { TranquiTheme } from '../../App/theme';

interface ValidationAttemptsCounterProps {
  remainingAttempts: number | null | undefined;
  testId?: string;
}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  helperText: {
    color: theme.palette.text6.main,
  },
}));

/**
 * Componente reutilizable para mostrar el contador de intentos restantes
 * en los métodos de validación de identidad.
 *
 * Muestra: "Te quedan X intentos" y "X/3"
 */
const ValidationAttemptsCounter: React.FC<ValidationAttemptsCounterProps> = ({
  remainingAttempts,
  testId = 'IdentificationConfirmation__triesValidation-helper',
}) => {
  const classes = useStyles();

  // No mostrar nada si remainingAttempts es null o undefined
  if (remainingAttempts === null || remainingAttempts === undefined) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="space-between" data-testid="info__retries">
      <FormHelperText className={classes.helperText} data-testid={testId}>
        <RenderText textKey="validation_tries" context={{ value: String(remainingAttempts) }} />
      </FormHelperText>
      <FormHelperText className={classes.helperText}>
        {remainingAttempts}
        /
        {MAX_VALIDATION_ATTEMPTS}
      </FormHelperText>
    </Box>
  );
};

export default ValidationAttemptsCounter;
